import {PromotionGateway} from '../../../../core-logic/gateways/api-services/promotion-gateway';
import {PromotionCreateModel} from '../../../../core-logic/models/promotion/promotion-create-model';
import {PromotionModel} from '../../../../core-logic/models/promotion/promotion-model';
import {ErrorModel} from '../../../../core-logic/models/shared/error-model';
import {Observable} from 'rxjs';
import {environment} from '../../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {PromotionUpdateModel} from '../../../../core-logic/models/promotion/promotion-update-model';
import {LoyaltyCardIdLocationModel} from 'src/app/core-logic/models/shared/loyalty-card-id-location-model';
import {CustomerPromotionModel} from '../../../../core-logic/models/promotion/customer-promotion-model';
import {LocationModel} from '../../../../core-logic/models/address/address-model';

@Injectable({providedIn: 'root'})
export class PromotionGatewayHttp implements PromotionGateway {
  constructor(private httpClient: HttpClient) {
  }

  createPromotion(promotionCreateModel: PromotionCreateModel, imageBlob?: Blob): Observable<PromotionModel | ErrorModel> {
    const formData = new FormData();
    if (imageBlob) { formData.append('picture_file', imageBlob); }
    formData.append('promotion', JSON.stringify(promotionCreateModel));
    return this.httpClient.post<PromotionModel | ErrorModel>(`${environment.fydlApi.url}/api/promotion`, formData);
  }

  updatePromotion(promotionId: string, promotionUpdateModel: PromotionUpdateModel, imageBlob?: Blob): Observable<Boolean | ErrorModel> {
    const formData = new FormData();
    if (imageBlob) { formData.append('picture_file', imageBlob); }
    formData.append('promotion_update', JSON.stringify(promotionUpdateModel));
    return this.httpClient.put<Boolean | ErrorModel>(`${environment.fydlApi.url}/api/promotion/${promotionId}`, formData);
  }

  getPromotionPicture(pictureId: string): Observable<Blob> {
    // @ts-ignore
    return this.httpClient.get<Blob>(`${environment.fydlApi.url}/api/promotion/picture/${pictureId}`, { responseType: 'blob' });
  }

  deletePromotionById(promotionId: string): Observable<boolean | ErrorModel> {
    return this.httpClient.delete<boolean | ErrorModel>(`${environment.fydlApi.url}/api/promotion/${promotionId}`);
  }

  viewPromotionById(promotionId: string): Observable<boolean | ErrorModel> {
    return this.httpClient.post<boolean | ErrorModel>(`${environment.fydlApi.url}/api/promotion/${promotionId}/view`, {});
  }

  enableDisablePromotionById(promotionId: string): Observable<boolean | ErrorModel> {
    return this.httpClient.get<boolean | ErrorModel>(`${environment.fydlApi.url}/api/promotion/${promotionId}/enable-disable`);
  }

  getLoyaltyCardPromotions(loyaltyCardIdLocationModel: LoyaltyCardIdLocationModel): Observable<CustomerPromotionModel[] | ErrorModel> {
    const params = loyaltyCardIdLocationModel.location ? { params: new HttpParams({fromObject: { lng: loyaltyCardIdLocationModel.location.coordinates[0],
          lat: loyaltyCardIdLocationModel.location.coordinates[1]}
      })} : {};
    return this.httpClient.get<CustomerPromotionModel[] | ErrorModel>(`${environment.fydlApi.url}/api/promotion/loyalty-card/${loyaltyCardIdLocationModel.loyalty_card_id}`,
      params
    );
  }

  getLoyaltiesCardsPromotions(location?: LocationModel): Observable<CustomerPromotionModel[] | ErrorModel> {
    const params = location ? { params: new HttpParams({fromObject: { lng: location.coordinates[0],
          lat: location.coordinates[1]}
      })} : {};
    return this.httpClient.get<CustomerPromotionModel[] | ErrorModel>(`${environment.fydlApi.url}/api/promotion/loyalties-cards`,
      params
    );
  }

}
